import React, { useState, useEffect } from "react";
import { FaTree } from "react-icons/fa";

import BannerCarousel from "../components/BannerCarousel";
import WPAImageBanner from "../components/WPAImageBanner";
import WPAColoredBanner from "../components/WPAColoredBanner";
import { GroqDrawerTrigger } from "../components/GroqDrawerTrigger";
import RSSHeadlines from "../components/RSSHeadlines";
import ORClogo from "../assets/ORClogo.png";


const HomePage = () => {
  const [transitioning, setTransitioning] = useState(false);

  // Banner images in src/assets/BannerImages (relative for production)
  const bannerImages = [
    require("../assets/BannerImages/four.point_.adventures.1600x800.jpg"),
    require("../assets/BannerImages/heritage.inspirations.1600x800.jpg"),
    require("../assets/BannerImages/jackson.hole_.paragliding.1600x800.jpg"),
    require("../assets/BannerImages/moondance.sea_.kayak_.adventrues.1600x800.jpg"),
    require("../assets/BannerImages/seattle.mountain.bike_.tours_.1600x800.jpg"),
  ];

  const [bannerIndex, setBannerIndex] = useState(() => Math.floor(Math.random() * bannerImages.length));

  useEffect(() => {
    const interval = setInterval(() => {
      setTransitioning(true);
      setTimeout(() => {
        setBannerIndex((prev) => (prev + 1) % bannerImages.length);
        setTransitioning(false);
      }, 500); // transition duration
    }, 15000); // 15 seconds
    return () => clearInterval(interval);
  }, [bannerImages.length]);

  const randomBanner = bannerImages[bannerIndex];

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-green-50 dark:from-gray-900 dark:via-gray-800 dark:to-green-900">
      {/* Header */}
      <header className="bg-white dark:bg-gray-800 shadow-lg border-b border-gray-200 dark:border-gray-700">
        <div className="container mx-auto px-4 py-4 sm:py-6 md:py-8">
          <div className="flex flex-col items-center gap-3 text-center sm:flex-row sm:items-center sm:text-left sm:gap-4">
            <div>
              <h1
                className="text-xl sm:text-3xl font-bold tracking-widest uppercase font-rye"
                style={{
                  fontFamily: "Times New Roman, Times, serif",
                  fontSize: "2.625em",
                  letterSpacing: '0.12em',
                  color: '#111111'
                }}
              >
                
              </h1>
              <p className="text-gray-600 dark:text-gray-400 mt-2 text-sm sm:text-base md:text-lg">
               {/* Line deleted as requested */}
              </p>
            </div>
          </div>
        </div>
      </header>

      {/* Hero Section */}
  <main className="container mx-auto px-4 py-6 sm:py-8 md:py-12 flex flex-col items-center" style={{ background: 'rgb(169,184,195)', borderRadius: '1rem' }}>
        {/* Temporary WPA Colored Banner (mountain profile green) */}
        {/* <div className="mb-6 w-full">
          <WPAColoredBanner />
        </div> */}
        {/* Banner carousel */}
        <BannerCarousel />
        <p >
        </p>
        <section className="bg-white dark:bg-gray-800 rounded-xl shadow-lg border border-gray-200 dark:border-gray-700 p-4 sm:p-6 w-full">
          <h2 
            className="mb-2 text-gray-700 dark:text-gray-300"
            style={{
              fontFamily: 'Times New Roman, Times, serif',
              fontSize: '1.25em',
              fontWeight: 400,
              fontStyle: 'normal',
              letterSpacing: '0.5px'
            }}
          >
            What you can do:
          </h2>
          <ul className="list-disc pl-4 sm:pl-6 text-gray-700 dark:text-gray-300 space-y-2 text-xs sm:text-base">
           <li>YOGi is Your Online Guide for smart, personalized outdoor recreation suggestions.</li> 
            <li>Explore national and local parks</li>
            <li>Plan your next adventure</li>
            <li>Check real-time weather and park alerts</li>
            <li>Save your favorite spots with Field Notes</li>
          </ul>
        </section>

        <section className="bg-white dark:bg-gray-800 rounded-xl shadow-lg border border-gray-200 dark:border-gray-700 p-4 sm:p-6 w-full mt-6">
          <h2 
            className="mb-2 text-gray-700 dark:text-gray-300"
            style={{
              fontFamily: 'Times New Roman, Times, serif',
              fontSize: '1.25em',
              fontWeight: 400,
              fontStyle: 'normal',
              letterSpacing: '0.5px'
            }}
          >
            Latest Information
          </h2>
          <div className="text-gray-700 dark:text-gray-300 space-y-3 text-xs sm:text-base">
            {/* Only the Christmas tree item remains above the RSS headlines */}
            <div className="flex items-center gap-2">
              <FaTree className="text-green-600 dark:text-green-400 flex-shrink-0" size={16} />
              <span>Cutting your own Christmas tree with a permit from <a href="https://www.recreation.gov/tree-permits" target="_blank" rel="noopener noreferrer" className="text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 underline transition-colors duration-200">Recreation.gov</a> is a fun way to explore public lands while helping maintain healthy forests. These permits allow families to harvest small-diameter trees in designated areas, reducing overcrowding and supporting long-term forest health.</span>
            </div>
            {/* RSS Headlines Section */}
            <div className="mt-6 pt-4 border-t border-gray-200 dark:border-gray-600">
              <RSSHeadlines maxHeadlines={5} />
            </div>
          </div>
        </section>

        <section className="bg-white dark:bg-gray-800 rounded-xl shadow-lg border border-gray-200 dark:border-gray-700 p-4 sm:p-6 w-full mt-6">
          <h2 className="mb-2 text-gray-700 dark:text-gray-300"
            style={{
              fontFamily: 'Times New Roman, Times, serif',
              fontSize: '1.25em',
              fontWeight: 400,
              fontStyle: 'normal',
              letterSpacing: '0.5px'
            }}
          >
            Friends of Outdoorec
          </h2>
          <p className="text-gray-700 dark:text-gray-300 text-xs sm:text-base mb-4">
           We’re lucky to be part of the outdoor community — guides, shops, and organizations who care about getting outside and taking care of the places we play. Here are just a few friends who share that spirit.
          </p>
          <ul className="list-disc pl-4 sm:pl-6 text-gray-700 dark:text-gray-300 space-y-2 text-xs sm:text-base">
            <li>
              American Mountain Guides Association (AMGA) Accredited
              <div className="mt-2 ml-4 flex gap-4 items-center">
                <img 
                  src="https://cdn.prod.website-files.com/675b99cdcea5598fbb9ed531/68200ec6d42d54a9b79d54ef_logo.png" 
                  alt="Mountain Madness Logo" 
                  style={{ height: '3rem', width: 'auto', minWidth: 0, maxWidth: 'none' }}
                />
                <div className="bg-white rounded-lg p-2 flex items-center justify-center">
                  <img 
                    src="https://cdn.prod.website-files.com/675b99cdcea5598fbb9ed531/682018783dc65fa89a374899_cropped-smc_classic_small-file.png" 
                    alt="Sierra Mountain Center Logo" 
                    style={{ height: '3rem', width: 'auto', minWidth: 0, maxWidth: 'none' }}
                  />
                </div>
                <div className="bg-white rounded-lg p-2 flex items-center justify-center">
                  <img 
                    src="https://cdn.prod.website-files.com/675b99cdcea5598fbb9ed531/6820176c85b83fc21ff41176_images-2%201.avif" 
                    alt="Sawtooth Mountain Guides Logo" 
                    style={{ height: '3rem', width: 'auto', minWidth: 0, maxWidth: 'none' }}
                  />
                </div>
                <div className="bg-white rounded-lg p-2 flex items-center justify-center">
                  <img 
                    src="https://cdn.prod.website-files.com/675b99cdcea5598fbb9ed531/68201d0161e4643aad9d92d7_TMG-Logo-1-e1597063712612.avif" 
                    alt="Timberline Mountain Guides Logo" 
                    style={{ height: '3rem', width: 'auto', minWidth: 0, maxWidth: 'none' }}
                  />
                </div>
              </div>
            </li>
            <li>
              Partners
              <div className="mt-2 ml-4 flex gap-4 items-center">
                <img
                  src={require("../assets/LNT.jpg")}
                  alt="Leave No Trace Logo"
                  style={{ height: '3rem', width: 'auto', minWidth: 0, maxWidth: 'none', borderRadius: '0.5rem', background: 'white', padding: '0.25rem' }}
                />
              </div>
            </li>
          </ul>
        </section>

        <section className="bg-white dark:bg-gray-800 rounded-xl shadow-lg border border-gray-200 dark:border-gray-700 p-4 sm:p-6 w-full mt-6">
          <h2 className="mb-2 text-gray-700 dark:text-gray-300"
            style={{
              fontFamily: 'Times New Roman, Times, serif',
              fontSize: '1.25em',
              fontWeight: 400,
              fontStyle: 'normal',
              letterSpacing: '0.5px'
            }}
          >
            Awards
          </h2>
          <p className="text-gray-700 dark:text-gray-300 text-xs sm:text-base mb-4">
            Recognition and achievements that reflect our commitment to excellence in outdoor recreation services.
          </p>
          <div className="flex flex-col items-center">
            <img 
              src={require("../assets/Hospitality-Awards-Logo-For-Web.png")} 
              alt="Hospitality Awards Logo" 
              className="h-20 w-auto"
            />
            <div className="mt-3 text-center space-y-1">
              <p className="text-gray-700 dark:text-gray-300 text-sm sm:text-base font-medium">
                <a 
                  href="https://lux-life.digital/winners/outdoorec-llc/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 underline transition-colors duration-200"
                >
                  Most Innovative Outdoor Adventure Marketplace 2023 – USA
                </a>
              </p>
              <p className="text-gray-700 dark:text-gray-300 text-sm sm:text-base font-medium">
                Most Unique Rural Community Development Project 2023 – USA
              </p>
              <p className="text-gray-700 dark:text-gray-300 text-sm sm:text-base font-medium">
                <a 
                  href="https://lux-life.digital/winners/outdoorec-llc-2/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 underline transition-colors duration-200"
                >
                  Best Outdoor Recreation Technology Platform 2025
                </a>
              </p>
            </div>
          </div>
        </section>
      </main>

      {/* Yogi Assistant (GroqDrawerTrigger) */}
      <GroqDrawerTrigger />
    </div>
  );
};

export default HomePage;
